import { WHERE_FIELDS, WHERE_OPERATORS, type WhereDataset } from '@parcel/filters';

type JsonSchema = Record<string, unknown>;

export const WHERE_SCHEMA_DESCRIPTION =
  'Condition {combinator:"and"|"or", not?, rules:[{field, operator, value} | nested group]}. Rules in one group on one dotted prefix (project., firm., contact., signal.) match the same linked record. Operators and values per field: search_fields({dataset:"workspace_<plural>"}).';

/** A dataset's where as JSON Schema: field keys as an enum, two inline levels and no $ref, so every client reads it. */
export function buildWhereSchema(dataset: WhereDataset): JsonSchema {
  const rule: JsonSchema = {
    type: 'object',
    additionalProperties: false,
    required: ['field', 'operator'],
    properties: {
      field: { enum: WHERE_FIELDS[dataset].map((f) => f.key) },
      operator: { enum: [...WHERE_OPERATORS] },
      value: {},
    },
  };
  const group: JsonSchema = {
    type: 'object',
    required: ['rules'],
    properties: {
      combinator: { enum: ['and', 'or'] },
      not: { type: 'boolean' },
      rules: { type: 'array', items: { type: 'object' } },
    },
  };
  return {
    type: 'object',
    additionalProperties: false,
    required: ['rules'],
    description: WHERE_SCHEMA_DESCRIPTION,
    properties: {
      combinator: { enum: ['and', 'or'] },
      not: { type: 'boolean' },
      rules: { type: 'array', maxItems: 40, items: { anyOf: [rule, group] } },
    },
  };
}
